import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-ellipsis-v z-40" }, null, -1);
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-edit mr-2" }, null, -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("em", { class: "fas fa-trash mr-2" }, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MenuButton = _resolveComponent("MenuButton");
    const _component_MenuItem = _resolveComponent("MenuItem");
    const _component_MenuItems = _resolveComponent("MenuItems");
    const _component_Menu = _resolveComponent("Menu");
    return (_openBlock(), _createBlock(_component_Menu, { as: "div" }, {
        default: _withCtx(() => [
            _createVNode(_component_MenuButton, { class: "border-none hover:text-blue-500 w-8 m-0" }, {
                default: _withCtx(() => [
                    _hoisted_1
                ]),
                _: 1
            }),
            _createVNode(_Transition, {
                "enter-active-class": "transition duration-100 ease-out",
                "enter-from-class": "transform scale-95 opacity-0",
                "enter-to-class": "transform scale-100 opacity-100",
                "leave-active-class": "transition duration-75 ease-in",
                "leave-from-class": "transform scale-100 opacity-100",
                "leave-to-class": "transform scale-95 opacity-0"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_MenuItems, {
                        class: _normalizeClass(["flex flex-col p-2 absolute bg-white border-2 border-gray-200 rounded z-80", _ctx.customClasses])
                    }, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "items", {}, () => [
                                _createVNode(_component_MenuItem, {
                                    class: "text-blue-400 cursor-pointer",
                                    onClick: _withModifiers(_ctx.editCategory, ["stop"])
                                }, {
                                    default: _withCtx(({ active }) => [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["opacity-80", { 'opacity-100': active }])
                                        }, [
                                            _hoisted_2,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.actions.edit')), 1)
                                        ], 2)
                                    ]),
                                    _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_MenuItem, {
                                    class: "text-red-400 cursor-pointer",
                                    onClick: _withModifiers(_ctx.deleteCategory, ["stop"])
                                }, {
                                    default: _withCtx(({ active }) => [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(["opacity-80", { 'opacity-100': active }])
                                        }, [
                                            _hoisted_3,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('misc.actions.delete')), 1)
                                        ], 2)
                                    ]),
                                    _: 1
                                }, 8, ["onClick"])
                            ])
                        ]),
                        _: 3
                    }, 8, ["class"])
                ]),
                _: 3
            })
        ]),
        _: 3
    }));
}
